import { render, staticRenderFns } from "./TambahLaporan.vue?vue&type=template&id=3109c5f3&"
import script from "./TambahLaporan.vue?vue&type=script&lang=js&"
export * from "./TambahLaporan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports